import { PCLN_GRAPH_URL, FLY_QL_URL, AIR_PRICE_GUIDE_URL, LOCAL_FLY_QL_URL } from './constants'
import { appendGqlOp } from '@mfs/common/utils/appendGqlOp'

const getFlexDatesURL = ({ skipPclnGraph }) => {
  if (skipPclnGraph) {
    return AIR_PRICE_GUIDE_URL
  }
  return PCLN_GRAPH_URL
}

const getFlyQLURLClientSide = ({ skipPclnGraph, useLocalFlyql }) => {
  let apiUrl = PCLN_GRAPH_URL
  if (useLocalFlyql) {
    return LOCAL_FLY_QL_URL
  }

  if (skipPclnGraph) {
    return FLY_QL_URL
  }
  return apiUrl
}

const getGraphURL = ({ skipPclnGraph, useLocalFlyql, operationName }) => {
  let URL = getFlyQLURLClientSide({
    skipPclnGraph,
    useLocalFlyql,
  })

  if (operationName?.includes('airPriceGuide')) {
    URL = getFlexDatesURL({ operationName, skipPclnGraph })
  }

  return appendGqlOp({ endpoint: URL, gqlOp: operationName })
}

export { getGraphURL }
